import { useEffect, useState } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { getClientById } from '../services/clientService';
import { useBreadcrumbStore } from '../store/useBreadcrumbStore';
import { PropertyList } from '../components/properties/PropertyList';

export default function PropertiesPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('clientId') || undefined;

  const [clientName, setClientName] = useState('');
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/properties') return;
    if (clientId) {
      getClientById(clientId).then((client) => {
        const name = client.name || clientId;
        setClientName(name);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: name, path: `/client-detail?clientId=${clientId}` },
          { label: 'Properties' },
        ]);
      });
    } else {
      setClientName('');
      setBreadcrumb([{ label: 'Properties' }]);
    }
  }, [location.pathname, clientId, setBreadcrumb]);

  const title = clientName ? `Properties - ${clientName}` : 'Properties';

  return (
    <IonPage>
      <IonContent>
        <PropertyList title={title} clientId={clientId} />
      </IonContent>
    </IonPage>
  );
}
